<template>
  <modal
    :is-opened="isOpened"
    :on-close="close"
    class="buyer-rdv"
  >
    <template #header>
      {{ trans('offer.match_rdv.title') }}
    </template>
    <template #body>
      <div class="buyer-rdv__main buyer-rdv-body">
        <p class="buyer-rdv-body__text">
          {{ trans('offer.match_rdv.text') }}
        </p>
        <div class="buyer-rdv-body__contact buyer-contact">
          <profile-picture
            :uuid="getContact.pic"
          />
          <span class="buyer-contact__name">{{ getContact.name }}</span>
          <span class="buyer-contact__job">{{ getContact.job }}</span>
        </div>
      </div>
    </template>
    <template #footer>
      <div class="buyer-rdv__calendly">
        <a class="btn btn--primary" target="_blank" :href="getContact.calendly">{{ trans('offer.match_rdv.cta') }}</a>
        <p><a href="#" class="" @click="close">{{ trans('offer.match_rdv.call_me_whenever') }}</a></p>
      </div>
    </template>
  </modal>
</template>

<script>
import Modal from '@components/Modal.vue';
import ProfilePicture from '@components/ProfilePicture.vue';
import { translationMixin } from '@elements/translation';

/**
 * Init RDV Component
 * This component use the modal component as a child.
 */
export default {
  components: { ProfilePicture, Modal },
  mixins: [ translationMixin ],
  props: {
    isOpened: { type: Boolean, default: false },
  },
  computed: {
    getContact() {
      return window.initialAppState.first_contact_after_creation;
    },
  },
  methods: {
    close() {
      this.$emit('close');
    },
  },
};
</script>
